var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricebox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-de523685-47eb-4280-8300-259ecdb92ec0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.65805 148.65805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-19eb8cc6-c2a3-498e-b86d-42d324685615",
    "data-name": "rectangle2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43538,141.2226l120.47268,.00007c5.19968-5.19968,8.11493-8.11493,13.31461-13.31461l-.00007-120.47268H20.74999c-5.19968,5.19968-8.11493,8.11493-13.31461,13.31461v120.47261Z",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.43538,
    y: 7.43542,
    width: 133.78722,
    height: 133.78722,
    transform: "translate(148.65794 148.65809) rotate(-179.99997)",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "142.58547 19.59648 147.65805 24.66906 147.65805 84.8659 141.22267 91.30128",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "129.06156 6.07257 123.98899 1 63.79214 1 57.35676 7.43538",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19.59648 142.58548 24.66906 147.65805 84.8659 147.65805 91.30128 141.22267",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6.07257 129.06156 1 123.98899 1 63.79215 7.43538 57.35677",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricebox);
export default __webpack_public_path__ + "static/media/pricebox.ee977c94066a9f8dcb62d608d3668255.svg";
export { ForwardRef as ReactComponent };